import React, { useState } from 'react';

function SurveyStepSeventeen({ formData, onNext }) {
    const [ideaEncouragement, setIdeaEncouragement] = useState(formData.ideaEncouragement || '');
    const [ideaComments, setIdeaComments] = useState(formData.ideaComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!ideaEncouragement) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ ideaEncouragement, ideaComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 4: Workplace & Culture</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How encouraged do you feel to contribute ideas for improvement? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`idea-encouragement-${option}`}
                            name="ideaEncouragement"
                            value={option}
                            checked={ideaEncouragement === option}
                            onChange={() => setIdeaEncouragement(option)}
                        />
                        <label htmlFor={`idea-encouragement-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={ideaComments}
                    onChange={(e) => setIdeaComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!ideaEncouragement}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepSeventeen;
